module.exports = {"showText":"show","hideText":"hide","isNotVisibleMsg":"Password is hidden","isVisibleMsg":"Password is visible","passwordPlaceholder":"Enter Password","passwordLabel":"Password","textLabel":"First Name","textPlaceholder":"First Name","textInputInfoMessage":"This is an info message","textInputErrorMessage":"This is an error message","copyrightText":"Pearson Education Inc. All Rights Reserved"}


//////////////////
// WEBPACK FOOTER
// ./demo/translations/en-US.json
// module id = ./demo/translations/en-US.json
// module chunks = 0